export default {
  setLoading(context, payload) {
    context.commit("SET_LOADING", payload);
  },
};
